// Add a new key here each release, matching APP_VERSION in server/app/Constants/version.js
export const CHANGELOG = {
  '4.8': {
    title: "What's New in Showroom Pricing",
    subtitle: "Here's what we added in this release.",
    features: [
      {
        title: 'Feature Requests',
        description:
          'Have an idea for Showroom Pricing? The new Feature Requests page lets you vote on ideas other customers have submitted, join the discussion in comments, and submit requests of your own — and see where each request stands. Find it in the navigation menu.',
        tourKey: 'featureRequests',
      },
      {
        title: 'Help Video Catalog',
        description:
          'The Help page now hosts a searchable library of walkthrough videos. Start typing what you\'re trying to do and the search instantly surfaces the right video — new videos appear automatically as they\'re published, no app update required.',
        tourKey: 'helpCatalog',
      },
      {
        title: 'Timezone Support',
        description:
          'Timestamps across the app now respect your timezone. Admins set a company default under Settings, and each user can choose their own timezone on their profile page — every date and time shown in the app follows along.',
        tourKey: 'timezone',
      },
    ],
  },
  '4.7': {
    title: "What's New in Showroom Pricing",
    subtitle: "Here's what we added in this release.",
    features: [
      {
        title: 'New Navigation Menu',
        description:
          'The top navigation has been redesigned into a single dropdown menu in the upper right corner. Product Search is featured at the top for quick access, and the rest of the menu is organized into sections — Navigate, Admin, and Account — so everything is easier to find in one place.',
        tourKey: 'nav',
      },
      {
        title: 'Banner Search Bar',
        description:
          'A new search bar now lives in the top banner so you can search your product catalog from anywhere in the app without navigating away from the current page. Type a product name, style, or SKU and jump straight to the results.',
        tourKey: 'headerSearch',
      },
      {
        title: 'QR Code Styling',
        description:
          'Price tag QR codes are now fully customizable — choose foreground and background colors, dot and corner shapes, and upload your own logo to appear in the center. Color rules can also be set based on price ranges so QR codes change appearance automatically depending on the product\'s price. Configure everything under Settings.',
        tourKey: 'qr',
      },
      {
        title: 'Printed Product Indicator',
        description:
          'Products that have had a QR code printed now show a small printer icon in the search results list. Hover over it to confirm a label has been generated for that product, so your team always knows which items are ready on the floor.',
        tourKey: 'printedIndicator',
      },
      {
        title: 'Duplicate Product Detection',
        description:
          'When a product has a known duplicate in the catalog, you\'ll now see an indicator directly on the product search results page and on the product detail page. This makes it easy to spot and resolve duplicate entries without having to run a separate report.',
        tourKey: 'duplicates',
      },
      {
        title: 'Scan Dashboard',
        description:
          'A new Scan Dashboard brings all of your QR scan analytics onto one page. See total scans, unique products, and sample checkouts with period-over-period trends; a view → like → checkout funnel for every product; an hour-by-hour activity heatmap; manufacturer share; rising and falling products; per-location comparison; and a list of products that haven\'t been scanned at all. One global filter bar controls the whole page — date range, audience (customers vs staff), location, and whether to include only products that have had a QR label printed (on by default). Find it under "Scan Dashboard" in the navigation menu.',
      },
    ],
  },
};
